import React from 'react';
import { useTranslation } from 'react-i18next';
import BackEnd from '../components/BackEnd';
import Created from '../components/Created';
import Header from '../components/Header';

export default function BackEndPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-gray-600 text-white">
      <Header
        langSwitcher
        appsBackEnd={t('nav.projetos')}
        contatos={t('nav.contatos')}
        tecnologias={t('nav.tecnologias')}
        homePage={t('nav.homePage')}
      />
      <div className="flex flex-1 flex-col">
        <BackEnd />
      </div>
      <Created />
    </div>
  );
}
